// @purpose VIEW
// The /the-idea/experiment/ story engine (docs/design/HOW_IT_WORKS_SIM.md §2), browser side. Same maths as
// apps/consumer/howitworks/engine.py: a deterministic FICTIONAL model where each manager option is a pressure
// vector and each character's sensitivities come from their material's prototype profile. Pure functions, so
// frontend/tests/howitworks_engine.test.mjs can check it against the script. Constants come from
// content/howitworks/sim.json `engine` (story tuning values, not research coefficients).

export const BANDS = ["steady", "working", "carrying"];

/** §2.2: sensitivities from properties already on a 0..1 scale. */
export function sensitivities(p) {
  return {
    U: 1 - p.yield,
    C: 0.5 * (1 - p.ductility) + 0.5 * p.stiffness,
    S: p.porosity,
    R: 1 - p.fatigue,
    L: 1 - p.creep,
  };
}

/** §2.3: one decision for one character. */
export function step(ch, v, duration, carry, k) {
  const { p, s } = ch;
  const load =
    k.wU * v.U * s.U * (1 - k.piezo_relief * p.piezo) +
    k.wC * v.C * s.C +
    k.wS * v.S * s.S +
    k.wR * v.R * s.R +
    k.wL * duration * s.L;
  const output = v.U * p.piezo;
  const hidden = v.U * p.piezo * k.hidden_k * (1 - 0.5 * p.hardening);
  const felt = load + carry;
  const band = felt < k.steady_max ? 0 : felt < k.working_max ? 1 : 2;
  const shown = band === 1 && p.ductility < k.holds_shape_ductility ? 0 : band;
  let next = (carry + k.residual_k * load * p.residual + hidden) * (k.decay_base + k.decay_tau * p.tau);
  next *= 1 - v.Rest * (1 - 0.5 * p.tau);
  return { felt, output, band, shown, carry: next };
}

/** The quarter for a path of option keys: one row (cast order) per decision taken. */
export function run(cast, decisions, path, k, start = {}) {
  const carry = cast.map((c) => Number(start[c.id] || 0));
  const out = [];
  path.forEach((key, i) => {
    const d = decisions[i];
    const v = d.options[key];
    out.push(
      cast.map((ch, j) => {
        const r = step(ch, v, Number(d.duration || 0), carry[j], k);
        carry[j] = r.carry;
        return r;
      }),
    );
  });
  return out;
}
